"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnePerHundredCubicFeet = exports.OnePerGallon = exports.OnePerCubicMeter = exports.OnePerLiter = void 0;
var uom_1 = require("uom");
var UnitDivide = require("../unit-divide");
var volume_1 = require("./volume");
// Per Volume
exports.OnePerLiter = UnitDivide.dimensionlessByVolume("OnePerLiter", uom_1.Unit.One, volume_1.Liter);
exports.OnePerCubicMeter = UnitDivide.dimensionlessByVolume("OnePerCubicMeter", uom_1.Unit.One, volume_1.CubicMeter);
exports.OnePerGallon = UnitDivide.dimensionlessByVolume("OnePerGallon", uom_1.Unit.One, volume_1.Gallon);
exports.OnePerHundredCubicFeet = UnitDivide.dimensionlessByVolume("OnePerHundredCubicFeet", uom_1.Unit.One, volume_1.HundredCubicFeet);
//# sourceMappingURL=dimensionless-per-volume.js.map